<template>
  <div class="row padd-0">
    <div class="col-12" id="weekStyle">
      <h2 :class="isWeekday ? 'h2weekday' : 'h2weekend'">{{isWeekday ? 'Weekday' : 'Saturday'}}</h2>
      <div class="row" style="margin-bottom: 15px;margin-top: 10px;">
        <div class="col-3" v-if="isWeekday"></div>
        <div class="col-1"></div>
        <div class="col-8">
          <div class="row">
            <div class="col-3">Time On/Off</div>
            <div class="col-5">Time Slots</div>
            <div class="col-3">Suggest first</div>
          </div>
        </div>
      </div>

      <div class="row weekBorder" v-for="(el, index) in value" :key="'time-' + index">
        <div class="col-3 h100 timesStyle" v-if="isWeekday">
          <label>{{el.time}}</label>
        </div>
        <div class="col-1"></div>
        <div class="col-8 formStyle">
          <div class="row">
            <div class="col-3">
              <b-form-checkbox
                :id="'onoff-' + isWeekday ? '' : 'end-' + index"
                v-model="value[index].onoff"
                :state="el.onoff "
              ></b-form-checkbox>
            </div>

            <div class="col-5" style="padding: 0 5px 0 5px;">
              <b-form-select
                :id="'weekDaytimeSlots' + index"
                v-model="value[index].timeSlots"
                :options="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                class="timeslot-style"
                :disabled="!el.onoff"
              ></b-form-select>
            </div>

            <div class="col-3 h100 timePref">
              <b-form-checkbox
                :id="'pref-' + isWeekday ? '' : 'end-' + index"
                v-model="value[index].prefTime"
                switch
                :disabled="!el.onoff || el.prefTime === false && value.filter(elm => elm.prefTime === true && elm.onoff === true).length >= 5"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="col-1" v-if="!isWeekday"></div>
        <div class="col-2" v-if="!isWeekday">
          <button type="button" class="btn" id="trashIco" v-on:click="$emit('removeTime', el.time)">
            <b-icon icon="trash"></b-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainTimeDisplay",
  props: {
    isWeekday: Boolean,
    value: Array
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style>
.padd-0 {
  padding: 0;
}
#weekStyle {
  padding-top: 20px;
  background-color: rgb(0, 0, 0, 0.05);
}

.h2weekday {
  color: rgb(0, 153, 255);
  text-align: end;
  padding-right: 9%;
}

.h2weekend {
  color: rgb(0, 153, 255);
  text-align: left;
  padding-left: 10%;
}
.weekBorder {
  height: 45px;
  border-bottom: 1px solid #00000054;
  margin-top: 7px;
}
.timesStyle {
  padding-top: 4px;
  font-size: 20px;
  font-weight: 500;
}
.h100 {
  height: 100%;
}
.formStyle {
  padding-top: 3px;
}
.timeslot-style {
  min-width: max-content;
  background-color: transparent;
  border: 0;
  max-width: max-content;
}
.timePref {
  margin-right: 0;
  padding-left: 3%;
  padding-right: 0;
}
#trashIco {
  height: 45px;
}
</style>




